import React, { useEffect, useState } from 'react';
import './Accordion.scss';
import classNames from 'classnames';
import { IComponent } from '../../component';
import { RenderComponentWithWrapper } from '../Gallery/RenderComponent';
import SwipeableViews from 'react-swipeable-views';

export interface IAccordion {
  title: string;
  expand?: number;
  children: IComponent[];
}
const Accordion = function(props: IAccordion) {
  const [show, setShow] = useState(false);
  const [clientHeight, setClientHeight] = useState(0);

  const arrowCns = classNames('icon-right-arrow', {
    down: show
  });
  const contentCns = classNames('accordion-content');
  const contentRef = React.createRef<HTMLDivElement>();

  const clickShow = () => {
    setShow(prevState => !prevState);
    setTimeout(() => {
      window.dispatchEvent(new Event('custom-tab-height-change'));
      // 必须等动画完成（目前是300ms）后才能去变更高度
    }, 300);
  };

  useEffect(() => {
    if (contentRef.current && show) {
      const { children } = contentRef.current;
      if (!children || !children.length) {
        setClientHeight(18); // 默认标准传入字符串时，高度是18px
      } else {
        setClientHeight(children[0].clientHeight);
        window.dispatchEvent(new Event('custom-tab-height-change'));
      }
    }
  }, [show]);

  useEffect(() => {
    if (typeof props.expand != 'undefined') {
      let expand = Number(props.expand);
      if (expand === 0) {
      } else {
        clickShow();
      }
    } else {
      clickShow();
    }
  }, []);

  return (
    <div className="accordion">
      <div className="accordion-title" onClick={clickShow}>
        <div className="main-title">
          {(props.title || '').split(/\n/gi).map((line, index) => {
            return (
              <React.Fragment key={index}>
                {index != 0 ? <br /> : null}
                <span>{line}</span>
              </React.Fragment>
            );
          })}
        </div>
        <span className={arrowCns} />
      </div>
      <div
        ref={contentRef}
        className={contentCns}
        style={{ height: show ? 'auto' : 0 }}
      >
        {/*<SwipeableViews enableMouseEvents animateHeight={true} disabled={true}>
          {props.children.map((child, index) => (
            <React.Fragment key={index}>
              <RenderComponentWithWrapper {...child} />
            </React.Fragment>
          ))}
        </SwipeableViews>*/}
        {props.children.map((child, index) => (
          <React.Fragment key={index}>
            <RenderComponentWithWrapper {...child} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Accordion;
